import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { CustomerRoutingModule } from "./customer-routing.module";
import { ProfileComponent } from "./profile/profile.component";
import { MatTabsModule } from "@angular/material/tabs";
import { AttachmentComponent } from "./attachment/attachment.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AddFollowupComponent } from "./add-followup/add-followup.component";
import { AddTicketComponent } from "./add-ticket/add-ticket.component";
import { AddSubscriptionComponent } from "./add-subscription/add-subscription.component";
import { ViewHistoryComponent } from "./view-history/view-history.component";
import { MatIconModule } from "@angular/material/icon";
import { AddCommentComponent } from "./add-comment/add-comment.component";
import { AddSalesAlertComponent } from "./add-sales-alert/add-sales-alert.component";
import { AddTrainerTicketComponent } from "./add-trainer-ticket/add-trainer-ticket.component";
import { BlockClientComponent } from "./block-client/block-client.component";
import { EditCustomerComponent } from "./edit-customer/edit-customer.component";
import { CashbackComponent } from "./cashback/cashback.component";
import { InvitationComponent } from "./invitation/invitation.component";
import { PaymentsComponent } from "./payments/payments.component";
import { FreezeHistoryComponent } from "./freeze-history/freeze-history.component";
import { BenefitUsageHistoryComponent } from "./benefit-usage-history/benefit-usage-history.component";
import { ChangesLogComponent } from "./changes-log/changes-log.component";
import { AttendanceHistoryComponent } from "./attendance-history/attendance-history.component";
import { Invitation2Component } from "./invitation2/invitation2.component";
import { RequestServiceComponent } from "./request-service/request-service.component";
import { EditSalesRepresentativeComponent } from "./edit-sales-representative/edit-sales-representative.component";
import { EditCoachComponent } from "./edit-coach/edit-coach.component";
import { InvoiceComponent } from "./invoice/invoice.component";
import { EditPlanStartDateComponent } from "./edit-plan-start-date/edit-plan-start-date.component";
import { InnerTransferComponent } from "./inner-transfer/inner-transfer.component";
import { OuterTransferComponent } from "./outer-transfer/outer-transfer.component";
import { UpgradeComponent } from "./upgrade/upgrade.component";
import { DowngradeComponent } from "./downgrade/downgrade.component";
import { RefundComponent } from "./refund/refund.component";
import { EditSubscriptionBenefitsComponent } from "./edit-subscription-benefits/edit-subscription-benefits.component";
import { CancelSubscriptionComponent } from "./cancel-subscription/cancel-subscription.component";
import { SendMessageComponent } from './send-message/send-message.component';

@NgModule({
  declarations: [
    ProfileComponent,
    AttachmentComponent,
    AddFollowupComponent,
    AddTicketComponent,
    AddSubscriptionComponent,
    ViewHistoryComponent,
    AddCommentComponent,
    AddSalesAlertComponent,
    AddTrainerTicketComponent,
    BlockClientComponent,
    EditCustomerComponent,
    CashbackComponent,
    InvitationComponent,
    PaymentsComponent,
    FreezeHistoryComponent,
    BenefitUsageHistoryComponent,
    ChangesLogComponent,
    AttendanceHistoryComponent,
    Invitation2Component,
    RequestServiceComponent,
    EditSalesRepresentativeComponent,
    EditCoachComponent,
    InvoiceComponent,
    EditPlanStartDateComponent,
    InnerTransferComponent,
    OuterTransferComponent,
    UpgradeComponent,
    DowngradeComponent,
    RefundComponent,
    EditSubscriptionBenefitsComponent,
    CancelSubscriptionComponent,
    SendMessageComponent,
  ],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    MatTabsModule,
    FormsModule,
    MatIconModule,
    ReactiveFormsModule,
  ],
  exports: [ProfileComponent],
})
export class CustomerModule {}
